import { createQueryKeys } from '@lukemorales/query-key-factory';

import type { FetchUserDocumentsArgs } from '../api/types/userDocument.types';

import { fetchUserDocuments } from '../api/userDocument.api';

export const userDocumentQueryKeys = createQueryKeys('userDocument', {
  fetchUserDocuments: ({ organizationId, userId }: FetchUserDocumentsArgs) => ({
    queryFn: () => fetchUserDocuments({ organizationId, userId }),
    queryKey: [userId, organizationId],
  }),
});
